module.exports = __webpack_public_path__ + "static/media/blom-pysanky-thumb-5.dd99d71e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-thumb-5.jpg
// module id = 4007
// module chunks = 15